import {ShortcutView} from "@src/pages/workspace/shortcut-view/shortcut-view";
import {createFileRoute, useMatches, useParams} from "@tanstack/react-router";
import {TIntegration, TShortcut} from "@zeg/instant/types";
import {useShortcut} from "@zeg/instant/w/useShortcuts";

// Define the expected shape of the data from useShortcut after modifications
interface TShortcutWithIntegrations extends TShortcut {
  integrations?: TIntegration[];
}

export const Route = createFileRoute(
  "/_auth/_work-layout/$workspaceSlug/shortcuts/$shortcutSlug/"
)({component: RouteComponent});

function RouteComponent() {
  const {workspaceSlug, shortcutSlug} = useParams({
    from: "/_auth/_work-layout/$workspaceSlug/shortcuts/$shortcutSlug/",
  });
  const accumulatedContext = useMatches({
    select: (matches) => matches[matches.length - 1].context,
  });
  const {data, isLoading, error} = useShortcut(
    workspaceSlug as string,
    shortcutSlug as string
  );
  const shortcut = data?.workspaces?.[0]?.shortcuts?.[0] as
    | TShortcutWithIntegrations
    | undefined;

  return (
    <ShortcutView
      data={shortcut}
      isLoading={isLoading}
      error={error ? (error as Error) : null}
      accumulatedContext={accumulatedContext}
    />
  );
}
